/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { connect } from 'react-redux';
// import { Provider } from "react-redux";
// import cashStore from "../CashManagement/store/cash.store";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';

import { Grid, Paper } from '@material-ui/core';
import { TabPanel } from '@material-ui/lab';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { indigo, orange, purple, red, green } from '@material-ui/core/colors';
// Material Icons
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import AirportShuttleIcon from "@material-ui/icons/AirportShuttle";
import ApartmentIcon from "@material-ui/icons/Apartment";
// Components
import Styling from './components/Mobile';
// import LinkDrive from './components/Linkify';
import TStest from './components/TypeS';
// import ThemeNeu from './components/Theme';
import LogoAnimation from './components/LogoAnimation'
// import CashFlowSpreadsheet from '../CashManagement/container/Spreadsheet';

export const electronTheme = {
  palette: {
    type: 'light',
    primary: {
      main: purple.A400,
      light: purple['300'],
      dark: purple['600']
    },
    secondary: {
      main: orange.A700,
      light: orange['300'],
      dark: orange['600']
    },
    info: { main: indigo['600'] },
    error: { main: red['600'] },
    success: { main: green['600'] },
  },
};

const TestingTabs = (props) => {
  const { cashState, themeMode } = props;
  const [tab, setTab] = useState('2');
  // const eTheme = createMuiTheme({...electronTheme, palette:{...electronTheme.palette, type:themeMode}});
  return (
    // <Provider store={cashStore}>
    // <MuiThemeProvider theme={eTheme}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Paper square>
          <TabContext value={tab}>
            <TabList
              onChange={(event, NewValue) => setTab(NewValue)}
              variant="standard"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab icon={<AddToQueueIcon />} label="Mobile" value={'0'} />
              <Tab icon={<AirportShuttleIcon />} label="link preview" value={'1'} />
              <Tab icon={<ApartmentIcon />} label="FPGA" value={'2'} />
              <Tab icon={<AddToQueueIcon />} label="TS playground" value={'3'} />
              <Tab icon={<AddToQueueIcon />} label="Muitheme" value={'4'} />
              <Tab icon={<AirportShuttleIcon />} label="animation" value={'5'} />


            </TabList>
            <TabPanel style={{ padding: 0, paddingTop: '0.5rem' }} value={'0'}>
              <button
                onClick={() => {
                  console.log('cashState', cashState);
                }}
              >
                Print Store
              </button>
              <Styling inOut={false} />
              {/* <CashFlowSpreadsheet /> */}
            </TabPanel>
            <TabPanel value={'1'}>
              {/* <LinkDrive /> */}
            </TabPanel>
            <TabPanel value={'2'}>
                testing component FPGA 
              <div>
                {<>{false&&<div>0</div>}</>&&<div>1</div>}
              </div>
            </TabPanel>
            <TabPanel value={'3'}>
              <div>
                TS
                <TStest showValue msg="high" />
              </div>
            </TabPanel>
            <TabPanel value={'4'}>
              {/* <ThemeNeu /> */}
            </TabPanel>
            <TabPanel value={'5'}>
              <LogoAnimation />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>

    // </MuiThemeProvider>
    // </Provider>
  );
};


const mapStateToProps = (state) => ({
  cashState: state,
  themeMode: state.navBarReducer.themeMode

});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(TestingTabs);
